module.exports = __webpack_public_path__ + "media/images/homepage/slider2_old-7479fd787ab3e5c3e8ff6f989e1582e0.png";